/**
 * Nome antigo/errado "BUFFET ARON 4 PORTAS" → nome real "BUFFET ARON 2.0"
 * (cadastro de Pontuação e confirmação do usuário).
 */

const CHAVE_MIGRACAO_LS = 'migracao-buffet-aron-4portas-v1';
const RE_4_PORTAS = /\bBUFFET\s+ARON\s+4\s+PORTAS\b/gi;
const RE_4_PORTAS_TEST = /\bBUFFET\s+ARON\s+4\s+PORTAS\b/i;
const NOME_CORRETO = 'BUFFET ARON 2.0';

export function corrigirNomeBuffetAron4Portas(texto: string): string {
  return String(texto || '').replace(RE_4_PORTAS, NOME_CORRETO);
}

/** Aplica a correção em um campo de nome de lista (lotes / cards). */
export function corrigirListaNomesBuffetAron4Portas<T>(
  lista: T[],
  campo: keyof T & string
): T[] {
  if (!Array.isArray(lista) || lista.length === 0) return lista;
  let mudou = false;
  const next = lista.map((item) => {
    if (!item || typeof item !== 'object') return item;
    const v = (item as Record<string, unknown>)[campo];
    if (typeof v !== 'string' || !RE_4_PORTAS_TEST.test(v)) return item;
    mudou = true;
    return { ...item, [campo]: corrigirNomeBuffetAron4Portas(v) };
  });
  return mudou ? next : lista;
}

function corrigirDeep(valor: unknown): unknown {
  if (typeof valor === 'string') {
    return RE_4_PORTAS_TEST.test(valor) ? corrigirNomeBuffetAron4Portas(valor) : valor;
  }
  if (Array.isArray(valor)) return valor.map(corrigirDeep);
  if (valor && typeof valor === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(valor as Record<string, unknown>)) {
      out[k] = corrigirDeep(v);
    }
    return out;
  }
  return valor;
}

const CHAVES_LS = [
  'lotes-produtos-ade',
  'lotes-produtos',
  'produtos-tempo-corte-ade',
  'produto-palete-config-ade',
  'pontuacoes-produtos-ade',
] as const;

/** Uma vez: corrige localStorage legado que ainda tenha o nome antigo. */
export function aplicarMigracaoBuffetAron4PortasLocalStorage(): void {
  try {
    if (localStorage.getItem(CHAVE_MIGRACAO_LS) === '1') return;
  } catch {
    return;
  }
  for (const chave of CHAVES_LS) {
    try {
      const raw = localStorage.getItem(chave);
      if (!raw || !RE_4_PORTAS_TEST.test(raw)) continue;
      const parsed = JSON.parse(raw);
      localStorage.setItem(chave, JSON.stringify(corrigirDeep(parsed)));
    } catch {
      /* ignora */
    }
  }
  try {
    localStorage.setItem(CHAVE_MIGRACAO_LS, '1');
  } catch {
    /* quota */
  }
}
